export default {
      id: "integrations-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#integrations-usage",
      toString: function () {
        return this.url;
      }
    }